(function() {
    'use strict';

    angular
        .module('szallodak-menugenerator', ['ui.sortable']);
})();
